import AppLayout from "../../components/AppLayout";
import TableSystemAlerts from "../../components/tables/TableSystemAlerts";
import useSystemAlerts from "../../hooks/pages/admin/useSystemAlerts";
import NoDataMsg from "../../components/info/NoDataMsg";
import RoundedButton from "../../components/buttons/RoundedButton";
import { TbAlertOctagonFilled } from "react-icons/tb";
import CardContainer from "../../components/cards/CardContainer";

const SystemAlerts = () => {
  const {
    isLoading,
    alerts,
    viewLastDays,
    handleChangeView,
    handleMarkAsResolved,
    reloadTable
  } = useSystemAlerts();

  return (
    <AppLayout
      isLoading={isLoading}
      title="Panel de Administrador"
      tabType="admin"
      tab={3}
    >
      <CardContainer
        softTitle="alertas"
        mainTitle="Alertas del Sistema"
        description="Aquí puedes ver y gestionar las alertas generadas por el sistema para cada uno de los chatbots en funcionamiento."
      >
        <div className="m-4 mt-2">
          <div className="mb-2 d-flex justify-content-end">
            <span className="entity-values-badge">
              {viewLastDays ? `Últimos ${viewLastDays} días` : "Historial completo"}
            </span>
          </div>
          <div>
            {alerts.length > 0 ? (
              <TableSystemAlerts
                alerts={alerts}
                markAsResolved={handleMarkAsResolved}
                reloadTable={reloadTable}
              />
            ) : (
              <NoDataMsg
                title="Sin alertas del sistema"
                subtitle="No hay alertas generadas por el sistema en los últimos 30 días."
                icon={<TbAlertOctagonFilled />}
                buttons={[
                  <RoundedButton
                    color="trini"
                    label="Ver historial completo"
                    onClick={() => {
                      handleChangeView(null);
                    }}
                  />
                ]}
              />
            )}
          </div>
        </div>
      </CardContainer>
    </AppLayout>
  );
};

export default SystemAlerts;